var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCropsLeek(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4677 36.4194L19.1276 39.1098L17.2801 45L10.2903 40.9644L14.4677 36.4194Z",
    fill: "#D6F787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7277 38.0663L15.0678 35.3759C15.0678 35.3759 22.5505 18.8452 22.7788 9.91347C22.8948 5.37203 19.6651 1.85465 19.6651 1.85465L23.18 2.49261C23.18 2.49261 25.2582 5.74249 25.4499 7.97726C25.9524 13.8328 21.3539 27.1785 21.0126 30.4599C20.8194 32.3185 21.5351 34.9357 21.5351 34.9357L19.7277 38.0663Z",
    fill: "#82CC40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4219 26.2859C21.5945 30.7963 22.7395 32.8487 22.7395 32.8487C22.7395 32.8487 27.0529 25.9332 30.5317 22.0425C33.9711 18.1959 40.3526 13.1033 40.3526 13.1033L38.324 11.2363C38.324 11.2363 34.5201 13.1509 32.3991 14.7725C27.8108 18.2804 25.5538 21.0242 23.4219 26.2859Z",
    fill: "#36965C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7237 5.35215L28.6561 5.65381C28.6561 5.65381 29.6188 7.15104 29.1586 11.5094C28.927 13.7027 28.4961 16.6924 28.4961 16.6924C28.4961 16.6924 27.1643 17.5801 26.4757 18.3086C25.3383 19.5119 24.367 21.9609 24.367 21.9609C24.367 21.9609 25.9771 15.5441 26.2062 12.5875C26.5674 7.92632 25.7237 5.35215 25.7237 5.35215Z",
    fill: "#36965C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4395 11.7764C32.4554 12.919 29.9809 15.4634 29.9809 15.4634C29.9809 15.4634 30.2239 14.3143 30.3022 13.5618C30.4128 12.4976 30.3422 10.8022 30.3422 10.8022C30.3422 10.8022 32.3374 9.07581 34.1983 8.15871C35.5929 7.47141 38.0344 6.89509 38.0344 6.89509L39.4606 9.80556C39.4606 9.80556 36.2387 10.7404 34.4395 11.7764Z",
    fill: "#36965C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6089 4.81205C29.3143 4.87388 28.1427 4.66122 28.1427 4.66122L27.2989 2.08705L31.9988 2.01778C31.9988 2.01778 33.105 3.73114 33.425 4.92825C33.6558 5.7915 33.385 7.68789 33.385 7.68789C33.385 7.68789 32.8262 8.10833 32.2001 8.39512C31.5 8.71576 30.1314 9.28781 30.1314 9.28781C30.1314 9.28781 30.3806 7.60805 30.1714 6.52817C30.039 5.84519 29.6089 4.81205 29.6089 4.81205Z",
    fill: "#82CC40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_1590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsLeek);
export default __webpack_public_path__ + "static/media/ic-crops-Leek.c1f9e5f60e71e01957ea334bc51c0c9c.svg";
export { ForwardRef as ReactComponent };